import {get} from '@/lib/fetcher';

export default {
    namespaced: true,
    state: () => ({
        played: { Phases: {}}
    }),
    mutations: {
        changeDeals(state, newDeals) {
            state.played = newDeals;
        }
    },
    actions: {
        loadDeals({commit}) {
            get('/api/board/played')
                .then(resp => {
                    commit('changeDeals', resp);
                });
        },
    },
    getters: {
        played: state => state.played,
    }
};
